import React from 'react';

export const RollerBackRoll = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__b)"
        stroke="#233762"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      >
        <path
          d="M105.7 18.7L31.2 31.5c1.2 28.4 1.3 17.1 2.3 65.1l73.2-10-1-67.9z"
          fill="#8291ae"
          strokeWidth={2}
        />
        <path
          fill="#fff"
          strokeWidth={2}
          d="M33.5 31.1L105.7 19v24.2L33.5 55.3"
        />
        <ellipse
          cx={33.5}
          cy={43.2}
          rx={8.7}
          ry={12.1}
          fill="#fff"
          strokeWidth={2}
        />
        <ellipse
          cx={29.2}
          cy={43.2}
          rx={4.3}
          ry={6}
          fill="#fff"
          strokeWidth={1.578}
        />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
      <path
        d="M52.7 35.3C54.1 26.7 47.4 19 39 18.4c-8.8-.6-15.7 5.6-19.7 12.9 1.9-.9 3.9-1.9 5.9-2.7 2-.8 3.2 2.4 1.2 3.1-3.2 1.1-6.6 2.3-9.7 3.8-.9.4-1.7-.3-1.9-1.1-.7-3.3-1-6.6-.8-9.9 0-.4.4-.9.8-1 .3-.1.4-.2.7-.1.1 0 .2.1.2.1.4.1.7.6.8 1 .2 1.8.4 3.5.6 5.3 3.6-9.3 12.4-16.1 22.9-14.9 9.8 1.1 18 11 14 20.8-.2.7-1.4.4-1.3-.4z"
        fill="#11768b"
      />
    </svg>
  );
};
